// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  labelGroups: ['Claims Solutions', 'Property Estimating Solutions', 'Underwriting Solutions'],
  statusPages: [
    {
      region: 'US',
      label: 'Claims Solutions',
      statusPageUrl: 'https://servicenotify.statuspage.io',
      statusUrl: '/api/v2/status.json',
    },
    {
      region: 'US',
      label: 'Property Estimating Solutions',
      statusPageUrl: 'https://status.xactware.com',
      statusUrl: '/api/v2/status.json',
    },
    {
      region: 'EU',
      label: 'Property Estimating Solutions',
      statusPageUrl: 'https://statuseu.xactware.com',
      statusUrl: '/api/v2/status.json',
    },
    {
      region: 'US',
      label: 'Underwriting Solutions',
      statusPageUrl: 'https://iso-status.verisk.com',
      statusUrl: '/api/v2/status.json',
    },
    {
      region: 'EU',
      label: 'Underwriting Solutions',
      statusPageUrl: 'https://iso-international-status.verisk.com/',
      statusUrl: '/api/v2/status.json',
    },
  ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
